import React, { useState, useEffect, useCallback, useRef } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Checkbox, Responsive } from 'semantic-ui-react';
import { breakpoints } from 'helpers/breakpoints';
import { blockInvalidChar } from 'lib/block-invalid-char';
import EventsIcon from '../../../assets/events.svg';
import WarningIcon from '../../../assets/warning.svg';
import OpenInNewIcon from '../../../assets/open-in-new.svg';
import { Input } from '../../inputs';
import styles from './styles-module.css';
import { messages } from './locale';
import { ACTIVE, INACTIVE } from '../consts';
import LoadingSpinner from '../../loading';

const AddOnsCapacity = injectIntl((props) => {

  const { intl, eventData, rates, name, selectedTicketTypes, updateLimitCapacity,
    selectedCurrency, capacityLimitCustomization, listingIds, deletedRateIndex,
    setDeletedRateIndex, toggle, setToggle, dataLoader } = props;
  const [data, setData] = useState([]);
  const [limitCapacity, setLimitCapacity] = useState([]);
  const [capacityValue, setCapacityValue] = useState([]);
  const [ticketType, setTicketType] = useState([]);
  const hostingCount = eventData?.length || 0;
  const inputElementRef = useRef();

  useEffect(() => {
    if (ticketType.length && hostingCount > 0 && listingIds.length) {
      const filterData = eventData.filter((event) => ticketType.some(ticketValue => ticketValue.eventId === event.id));
      if (limitCapacity.length) {
        limitCapacity.forEach(event => {
          const filter = filterData.some(fData => fData.id === event.eventId);
          if (filter) {
            event.status = 1;
          } else {
            event.status = 0;
          }
        });
      }
      setLimitCapacity(limitCapacity);
      handleUpdateLimitCapacity(limitCapacity);
      setData(filterData);
    }
  }, [hostingCount, eventData, ticketType, limitCapacity, handleUpdateLimitCapacity, listingIds]);

  useEffect(() => {
    if (hostingCount > 0 && ticketType.length === 0) {
      if (limitCapacity.length) {
        limitCapacity.forEach((event) => {
          if (event.status === 0) {
            event.status = 1;
          }
        });
        setLimitCapacity(limitCapacity);
      }
      setData(eventData);
    }
  }, [hostingCount, eventData, ticketType, limitCapacity, handleUpdateLimitCapacity]);

  useEffect(() => {
    if (hostingCount > 0 && selectedTicketTypes !== undefined && listingIds.length) {
      const ticketArray = [];
      Object.keys(selectedTicketTypes).forEach(eventId => {
        const listingExist = listingIds.some(id => id === eventId);
        if (listingExist && selectedTicketTypes[eventId]) {
          ticketArray.push({eventId, ticketTypeIds: Array.from(selectedTicketTypes[eventId])});
        }
      });
      setTicketType(ticketArray);
    }
    if (listingIds.length === 0 || Object.keys(selectedTicketTypes).length === 0) {
      setTicketType([]);
    }
  }, [hostingCount, selectedTicketTypes, listingIds]);

  useEffect(() => {
    if (((data.length && capacityValue.length === 0) || (data.length !== capacityValue.length)) && toggle === ACTIVE) {
      const newCapacity = [];
      data.forEach(capacity => {
        const found = newCapacity.some(val => val === capacity.id);
        if (!found) {
          let prevCapacityValue = [];
          if (capacityValue) {
            capacityValue.forEach(capValue => {
              if (capValue[capacity.id]) {
                prevCapacityValue = capValue[capacity.id];
              }
            })
          }

          newCapacity.push({
            [capacity.id]: prevCapacityValue.length ?  prevCapacityValue : new Array(rates.length).fill('')
          });
        }
      });

      capacityLimitCustomization.forEach(capacity => {
        newCapacity.forEach(capIndex => {
          const rateIndex = rates.findIndex(rate => rate.id === capacity.rateId);
          if (rateIndex !== -1) {
            if ((capacity.capacityLimit !== null) && capIndex[capacity.listingId]) {
              capIndex[capacity.listingId][rateIndex] = capacity.capacityLimit;
            }
          }
        });
      });

      capacityLimitCustomization.forEach(customCapacity => {
        const capacityIndex = limitCapacity.findIndex(limitData => limitData.eventId === customCapacity.listingId);
        const rateIndex = rates.findIndex(rate => rate.id === customCapacity.rateId);
        if (rateIndex !== -1 && customCapacity.capacityLimit !== null) {
          if (capacityIndex !== -1) {
            const rateExist = limitCapacity[capacityIndex].addOnRatesCapacity.findIndex(rateOption =>
              rateOption.option === rateIndex);
            if (rateExist === -1) {
              limitCapacity[capacityIndex].addOnRatesCapacity.push({
                option: rateIndex,
                rateId: customCapacity.rateId,
                capacityLimit: customCapacity.capacityLimit
              });
            }
          }
          else {
            limitCapacity.push({
              eventId: customCapacity.listingId,
              addOnRatesCapacity: [{
                option: rateIndex,
                rateId: customCapacity.rateId,
                capacityLimit: customCapacity.capacityLimit
              }],
              status: 1
            })
          }
        }
      });
      setLimitCapacity(limitCapacity);
      handleUpdateLimitCapacity(limitCapacity);
      setCapacityValue(newCapacity);
    }
  }, [data, capacityValue.length, capacityLimitCustomization, toggle, limitCapacity,
      rates, handleUpdateLimitCapacity, capacityValue]);

  useEffect(() => {
    if (deletedRateIndex !== null && capacityValue.length) {
      capacityValue.forEach(value => {
        Object.values(value).forEach(capacitylimit => {
          capacitylimit.splice(deletedRateIndex, 1);
          rates.forEach((_, key) => {
            if (capacitylimit[key] === undefined) {
              capacitylimit[key] = '';
            }
          })
        });
      });

      limitCapacity.forEach(limit => {
        const addOnRateIndex = limit.addOnRatesCapacity.findIndex(delIndex => delIndex.option === deletedRateIndex);
        if (addOnRateIndex !== -1) {
          limit.addOnRatesCapacity.splice(addOnRateIndex, 1);
        }
        limit.addOnRatesCapacity.forEach((addonRate, addOnRateKey) => {
          if (addonRate.option !== addOnRateKey) {
            addonRate.option -= 1;
          }
        });
      });
      setCapacityValue([...capacityValue]);
      setLimitCapacity(limitCapacity);
      handleUpdateLimitCapacity(limitCapacity);
      setDeletedRateIndex(null);
    }
  },[deletedRateIndex, capacityValue, setDeletedRateIndex, handleUpdateLimitCapacity, limitCapacity, rates]);

  useEffect(() => {
      capacityLimitCustomization.forEach(limitValue => {
        if (limitValue.capacityLimit !== null) {
          setToggle(ACTIVE);
        }
      })
  }, [setToggle, capacityLimitCustomization]);

  const handleAddOnsCapacityChange = (value) => {
    const toggleValue = value === ACTIVE ? INACTIVE : ACTIVE;
    if (toggleValue === INACTIVE) {
      setLimitCapacity([]);
      setCapacityValue([]);
    }
    setToggle(toggleValue);
  }

  const renderNoEventsFound = () => {
    return (
      <div className={styles.noEventsContainer}>
        <div><EventsIcon /></div>
        <div>
          <FormattedMessage
            { ...messages.noEventsFound }
            values={{ currencyCode: selectedCurrency }}
          />
        </div>
        <Link to="/create" target="_blank" rel="noopener noreferrer" className={styles.createEventButton}>
          {intl.formatMessage(messages.createEvent)} <OpenInNewIcon />
        </Link>
      </div>
    );
  }

  const handleUpdateLimitCapacity = useCallback(limitArray => {
    const prepareLimitArray = [];
    if (toggle === ACTIVE) {
      limitArray.forEach(limit => {
        prepareLimitArray.push({
          eventId: limit.eventId,
          ticketTypeIds: [],
          addOnRatesCapacity:
            limit.addOnRatesCapacity.filter(addOn => (limit.status === 1 && addOn.capacity !== ''))
        });
      });
    }
    updateLimitCapacity(prepareLimitArray);
  }, [updateLimitCapacity, toggle]);

  const renderHeader = () => {
    return <div className={styles.listingsTableHeader}>
      <div className={styles.column}>
        {intl.formatMessage(messages.eventName)}
      </div>
      <div className={styles.column}>
        {intl.formatMessage(messages.quantityTimeslot)}
      </div>
    </div>
  };

  const updateCapacity = (eventId, rowIndex, value, rateId) => {
    const capacityExist = limitCapacity.some(limitData => limitData.eventId === eventId);
    let capacityValueIndex;
    Object.values(capacityValue).forEach((val, key) => {
      if (val[eventId]) {
        capacityValueIndex = key;
      }
    });

    if (capacityExist) {
      const index = limitCapacity.length && limitCapacity.findIndex(limitIndex => limitIndex.eventId === eventId);
      const capacityOptionIndex = limitCapacity.length &&
        limitCapacity[index].addOnRatesCapacity.findIndex(addon => addon.option === rowIndex);
      let capacityIndex = null;
      capacityValue.forEach((val, key) => {
        if (Object.keys(val)[0] === eventId) {
          capacityIndex = key;
        }
      });
      if (capacityOptionIndex !== -1) {
        const updatedOption = {
          option: rowIndex,
          rateId,
          capacityLimit: parseInt(value, 10)
        }
        const newRates = [
          ...limitCapacity[index].addOnRatesCapacity.slice(0, capacityOptionIndex),
          updatedOption,
          ...limitCapacity[index].addOnRatesCapacity.slice(capacityOptionIndex + 1)
        ];
        limitCapacity[index].addOnRatesCapacity = newRates;
        capacityValue[capacityIndex][eventId][rowIndex] = value;
        if (value === '') {
          limitCapacity[index].addOnRatesCapacity.splice(capacityOptionIndex, 1);
        }
        setCapacityValue(capacityValue);
      }
      else {
        limitCapacity[index].addOnRatesCapacity.push({
          option: rowIndex,
          rateId,
          capacityLimit: parseInt(value, 10)
        });
        if (capacityValueIndex !== undefined) {
          capacityValue[capacityValueIndex][eventId][rowIndex] = value;
        } else {
          capacityValue[capacityIndex][eventId].push(value);
        }
        setCapacityValue(capacityValue);
      }
    }
    else {
      limitCapacity.push({
        eventId,
        addOnRatesCapacity: [{
            option: rowIndex,
            rateId,
            capacityLimit: parseInt(value, 10)
          }],
        status: 1
      });

      if (capacityValueIndex !== undefined) {
        capacityValue[capacityValueIndex][eventId][rowIndex] = value;
      }
      else {
        capacityValue.forEach(capacityObj => {
          Object.keys(capacityObj).forEach(val => {
            if (val === eventId) {
              capacityObj[val].push(value);
            }
          });
        });
      }
    }
    setCapacityValue(capacityValue);
    setLimitCapacity(limitCapacity);
    handleUpdateLimitCapacity(limitCapacity);
  }

  const renderRatesOption = (dataId, datakey) => {
    let capacityIndex = null;
    capacityValue.forEach((val, key) => {
      if (val[dataId]) {
        capacityIndex = key;
      }
    });
    const rateCount = rates.length;
    return rates.map((rate, rateKey) => {
      const warningMsg = intl.formatMessage(messages.capacityLimitWarningMessage);
      let errorMsg = '';
      const currentCapacity = capacityValue[capacityIndex]?.[dataId].length
        ? capacityValue[capacityIndex]?.[dataId]?.[rateKey]
        : null;
      const hasCapacityError = () => {
        if (parseInt(currentCapacity, 10) === 0) {
          errorMsg = intl.formatMessage(messages.zeroLimitErrorMessage);
          return true;
        }
        return false;
      }
      const addOnCapacityClasses = `${styles.addOnInputs} ${hasCapacityError() ? 'error' : ''}`;
      const rateListRowClasses = `${styles.rateListingRow}
        ${(datakey === (data.length - 1)) && (rateKey === rateCount - 1) ? styles.rateListingLastRow : ''}`;
      return <>
        <div className={rateListRowClasses}>
          <div className={styles.rateListLabel}>
            {(rates.length === 1 && rate.optionName === null) ? name : rate.optionName}
          </div>
          <div className={styles.rateCapacity}>
          <Input
            ref={inputElementRef}
            value={currentCapacity}
            onChange={e => {updateCapacity(dataId, rateKey, e.target.value, rate.id)}}
            type="number"
            placeholder={intl.formatMessage(messages.capacityInputPlaceholder)}
            className={addOnCapacityClasses}
            min="1"
            onKeyDown={blockInvalidChar}
            isError={hasCapacityError()}
            errorMessage={errorMsg}
          />
          {
            (rate?.availability > 0 && (currentCapacity > rate?.availability)) &&
            <div className={styles.capacityWarning}> 
              <WarningIcon /> <span>{warningMsg}</span>
            </div>
          }
          </div>
        </div>
        {(datakey === (data.length - 1)) && (rateKey === rateCount - 1) ? '' : <div className={styles.line} />}
      </>
    });
  }

  const drawTable = () => {
    return <>
      <Responsive minWidth={breakpoints.tablet}>
        {data.length > 0 && data.map((event, key) => {
          return <>
            <div className={styles.desktopListingRow}>
              <div className={`${styles.column} ${styles.imageWrapper}`}>
                <img
                  src={event.imageUrl}
                  className={styles.image}
                  alt="listing_img"
                />
              </div>
              <div className={styles.title}>
                {event.title}
              </div>
            </div>
            <div className={styles.line} />
            {renderRatesOption(event.id, key)}
          </>})
        }
      </Responsive>
      <Responsive maxWidth={breakpoints.largestMobile}>
        {data.length > 0 && data.map((event, key) => {
          return <>
            <div className={styles.mobileListingRow}>
              <div className={`${styles.column} ${styles.imageWrapper}`}>
                <img
                  src={event.imageUrl}
                  className={styles.image}
                  alt="listing_img"
                />
              </div>
              <div className={styles.title}>
                {event.title}
              </div>
            </div>
            <div className={styles.line} />
            {renderRatesOption(event.id, key)}
          </>})
        }
      </Responsive>
    </>
  }

  return (
    <section className={`${styles.form} ${styles.capacityForm}`}>
      <div className={`${styles.addOnsTitle} ${styles.toggleCell}`}>
        <Checkbox
          toggle
          checked={toggle === ACTIVE}
          onChange={() => handleAddOnsCapacityChange(toggle)} 
        />
        <h3>
          {intl.formatMessage(messages.eventsCapacityTitle)}
        </h3>
      </div>
      <p className={styles.subtitle}>
        {intl.formatMessage(messages.eventsCapacitySubtitle)}
      </p>
      <div className={styles.headerTopLine} />
      {(dataLoader && toggle === ACTIVE)
        ? <div className={styles.row}>
            <LoadingSpinner className={styles.loadingSpinner} />
          </div> : (toggle === ACTIVE && ((hostingCount > 0)
        ? <> {renderHeader()}
          <div className={styles.line} />
          <div className={styles.listingTableContent}>
            {drawTable()}
          </div></>
        : <div className={styles.listingTableContent}>
            {renderNoEventsFound()}
          </div>))
      }
    </section>
  );
})

export default AddOnsCapacity;
